window.smoothScrollTo = (target) => {
  const duration = 250;
  let timer = null;
  let start = null;
  let factor = null;

  function scroll() {
    const offset = window.pageYOffset;
    const delta = target - window.pageYOffset;
    start = Date.now();
    factor = 0;
    if (timer) {
      clearInterval(timer);
    }

    function step() {
      let y = null;
      factor = (Date.now() - start) / duration;
      if (factor >= 1) {
        clearInterval(timer);
        factor = 1;
      }

      y = (factor * delta) + offset;
      window.scrollBy(0, y - window.pageYOffset);
    }
    timer = setInterval(step, 10);

    return timer;
  }

  scroll();
};
